import { connect } from "react-redux";
import CampaignList from "../CampaignList";
import { fetchCampaigns } from "../../../../actions/campaignActions";
import { getAllOrderedByStatusAndName } from "../../../../reducers/campaigns";
import { isUserInternal } from "../../../../reducers/currentUser";

const mapStateToProps = (state: any, props: any) => {
    return {
        campaigns: getAllOrderedByStatusAndName(state),
        loading: state.adwordsCampaigns.loading,
        clientId: state.clients.currentClient,
        isInternalUser: isUserInternal(state.currentUser)
    };
};

const mapDispatchToProps = (dispatch: any) => {
    return {
        fetchCampaigns: (clientId: number, refresh = false) => {
            dispatch(fetchCampaigns(clientId, refresh));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(CampaignList);
